export default __webpack_public_path__ + "static/media/190629_190332_IMG_8604.72e9c13d.jpg";